import APIV5 from '~/models/api';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

export default class ModalWfHistoryController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} affectList
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$injector,
		$scope,
		$timeout,
		$translate,
		$uibModalInstance,
		affectList,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;

		/** @type {any} */
		this.histo = {};

		this.affectList = affectList;

		(async () => {
			await this.init();
		})();
	}

	close() {
		this.$uibModalInstance.close();
	}

	copyToClipboard() {
		let value = `"${this.$translate.instant('common.date')}"`;
		for (const job of this.affectList) {
			value += `;"${job.wf.name.replace('"', '\\"')}"`;
		}
		for (const [date, histo] of Object.entries(this.histo)) {
			value += `\r\n"${this.$filter('date')(date, 'short')}"`;
			for (const job of this.affectList) {
				value += `;"${histo[job.kid].name.replace('"', '\\"')}"`;
			}
		}

		this.$copyToClipboard(value, true);
	}

	async init() {
		for (const affect of this.affectList) {
			const data = await APIV5.instance.wfAffectHisto({ wfaffect_kid: affect.kid }, { id: 'modal-wf-history.init' });
			for (const histo of data.histo.map(h => new WorkflowAffect(this.$injector, h))) {
				const k = histo.date?.toISOString();
				if (k) {
					if (!(k in this.histo)) {
						this.histo[k] = {};
					}
					if (!(affect.kid in this.histo[k])) {
						this.histo[k][affect.kid] = [];
					}
					this.histo[k][affect.kid].push({
						...histo,
						name: histo.getJobDescription(),
					});
				}
			}
		}

		this.histo = Object.keys(this.histo).sort((a, b) => {
			if (a < b) {
				return 1;
			}
			if (a > b) {
				return -1;
			}
			return 0;
			// eslint-disable-next-line unicorn/no-array-reduce
		}).reduce(
			(/** @type {any} */ job, /** @type {string} */ date) => {
				job[date] = this.histo[date];
				return job;
			},
			{},
		);

		this.$timeout(() => {
			this.$scope.$apply();
		});
	}
}
